import { adminPathBuilder } from '~/categories/admin/constants/adminPathBuilder';
import { localStorageKeys } from '~/constants/localStorageKeys';

export const redirectToLoginPath = (): void => {
  localStorage.setItem(localStorageKeys.admin.redirectionPath, location.href);
  location.replace(adminPathBuilder().login());
};
